// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2QQz8","content":"styles_content__10pM3","selectAll":"styles_selectAll__19tgM"};